const R = require('ramda')

const installStockState = require('./stockState/installClient')
const installStockChecks = require('./stockChecks/installClient')

module.exports = R.pipe(
  installStockState,
  installStockChecks,
)
